import {
  FaMedium,
  FaGithub,
  FaLinkedin,
  FaEnvelope,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiSubstack } from "react-icons/si";

export const links = [
  {
    index: 0,
    title: "Find me on Github",
    href: "https://github.com/john7rho",
    icon: <FaGithub />,
  },
  {
    index: 1,
    title: "Find me on LinkedIn",
    href: "https://www.linkedin.com/in/rhojohn/",
    icon: <FaLinkedin />,
  },
  {
    index: 2,
    title: "Find me on X",
    href: "https://x.com/john7rho",
    icon: <FaXTwitter />,
  },
  {
    index: 3,
    title: "Contact me via email",
    href: "mailto:johnrho21@gmail.com",
    icon: <FaEnvelope />,
  },
  {
    index: 4,
    title: "Find me on Medium",
    href: "https://johnrho.medium.com/",
    icon: <FaMedium />,
  },
  {
    index: 5,
    title: "Check out my Substack",
    href: "https://substack.com/@johnrho",
    icon: <SiSubstack />,
  },
];
